<template>
   <div>
        <v-container class="payment-method-container">
            <v-row>
                <v-col cols="12" class="custom-label py-0 px-3 mt-2">Select Terminal*</v-col>
                <v-col :cols="$vuetify.breakpoint.xs ? 12 : 6" class="py-0 px-3">
                    <v-select
                    :items="defaultReader"
                    v-model="device"
                    item-value="id"
                    item-text="name"
                    return-object
                    hide-details
                    dense
                    placeholder="Default Reader"
                    @change="setDevice"
                ></v-select>
                </v-col>
                
                <v-col cols="12" class="pl-2">
                    <v-checkbox v-if="paymentConfig.SHOW_SAVE_PAYMENT" class="mt-0 pt-0" hide-details :disabled="auto_charge" :input-value="payment_method.save_to_account" @change="updateSaveToAccount($event)" label="Save Payment Method"></v-checkbox>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapMutations } from "vuex";
import { EventBus } from '../../../EventBus';

export default {
    name: "TsysReader",
    data: () => ({
        defaultReader: [{
            id: null,
            connection_id: null,
            name: 'Default Reader',
            ip: '',
            port: ''
        }],
        device: {},
        isDropdownDisabled: false,
    }),
    props: ['auto_charge', 'dense_header', 'devices'],
    mounted() {
        if(this.devices && this.devices.length) {
            this.defaultReader = this.devices;
            this.device = this.defaultReader && this.defaultReader.length && this.defaultReader[0];
            this.setDevice();
        }
    },
    computed: {
        ...mapGetters({
          paymentConfig: 'paymentsStore/getPaymentSourceConfig',
          getErrors: 'paymentsStore/getErrors',
          payment_method: 'paymentsStore/getPaymentMethod',
        }),
    },
    created() {
        EventBus.$on('disable_reader_dropdown', ()=>{
            this.isDropdownDisabled = true;
        });
    },
    destroyed() {
      EventBus.$emit("setErrors", []);
      EventBus.$off('HB-Navigation:Search', ()=>{
        this.isDropdownDisabled = false;
      });

    },
    methods: {
        ...mapMutations({
            setCheckErrors: 'paymentsStore/setCheckErrors',
            setPaymentMethod: 'paymentsStore/setPaymentMethod',
        }),
        setDevice() {
            this.setPaymentMethod({property: 'device_id', propertyValue: this.device.id});
            this.setPaymentMethod({property: 'connection_id', propertyValue: this.device.connection_id});
        },
        updateSaveToAccount(val){
            this.setPaymentMethod({property: 'save_to_account', propertyValue: !!val}); 
        }
    },
    watch: {
        auto_charge: {
            handler() {
                this.setPaymentMethod({
                    property: 'save_to_account',
                    propertyValue: this.auto_charge
                });
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-label{
    font-size: 12px;
    font-weight: 400;
    color: #637381;
  }
</style>